// pages/HabitacionesEspeciales.js
import React, { useState, useEffect } from 'react';
import {
  Table,
  Button,
  Modal,
  Form,
  Input,
  Switch,
  Select,
  Space,
  Typography,
  message,
  Tag,
  Tooltip,
  Row,
  Col,
  Popconfirm,
  Badge,
  Statistic,
  Card,
  InputNumber,
  Divider,
  DatePicker,
  Segmented,
  Pagination,
  Alert
} from 'antd';
import {
  PlusOutlined,UnorderedListOutlined,
  EditOutlined,
  DeleteOutlined,CopyOutlined  ,
  SearchOutlined,
  ReloadOutlined,
  CheckCircleOutlined,
  CloseCircleOutlined,
  EyeOutlined,
  AppstoreOutlined,
  ExportOutlined,
  BarcodeOutlined,
  FileTextOutlined,
  DollarOutlined,
  OrderedListOutlined,
  SortAscendingOutlined,
  DownloadOutlined,
  PrinterOutlined,
  HomeOutlined,
  CalendarOutlined,
  FilterOutlined,
  InfoCircleOutlined,
  LockOutlined,
  UserOutlined,
  HistoryOutlined,TableOutlined 
} from '@ant-design/icons';
import axios from 'axios';
import dayjs from 'dayjs';

import PageContainer from '../components/PageContainer';
import { BASE_URL } from '../utils/constants';

const { Title, Text } = Typography;
const { Option } = Select;
const { RangePicker } = DatePicker;

const PlaningHabitacionesVenta = () => {
    // Estados principales
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [estadisticas, setEstadisticas] = useState(null);
    const [tiposHabitacion, setTiposHabitacion] = useState([]);

    const [vista, setVista] = useState('normal');    
  
    // Estados para filtros
    const [fechas, setFechas] = useState([]);
    const [fechasTexto, setFechasTexto] = useState('');
    const [tipoHabitacionFilter, setTipoHabitacionFilter] = useState('');
    const [diaSemanaFilter, setDiaSemanaFilter] = useState('');
    const [searchText, setSearchText] = useState('');
    const [searchLoading, setSearchLoading] = useState(false);

    const [todosLosTiposDisponibles, setTodosLosTiposDisponibles] = useState([]);  
  
    // Estados para vista
    const [modoVista, setModoVista] = useState('horizontal');
    const [expandedRows, setExpandedRows] = useState([]);
  
    // Estados para ordenamiento
    const [sortedInfo, setSortedInfo] = useState({});
    const [filteredInfo, setFilteredInfo] = useState({});

    // Días de la semana para filtro
    const diasSemana = [
        'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado', 'Domingo'
    ];

    const getColumnsHorizontal = () => {
        const baseColumns = [
            {
                title: 'Fecha',
                dataIndex: 'Fecha',
                key: 'Fecha',
                width: 90, // Más estrecho
                fixed: 'left',
                sorter: (a, b) => new Date(a.Fecha) - new Date(b.Fecha),
                sortOrder: sortedInfo.columnKey === 'Fecha' && sortedInfo.order,
                render: (fecha, record) => (
                    <div>
                        <div style={{ fontWeight: 'bold', fontSize: '12px' }}>
                            {dayjs(fecha).format('DD/MM')}
                        </div>            
                        <div style={{ fontSize: '10px', color: '#666' }}>
                            {record.DiaSemana.substring(0, 3)}
                        </div>
                    </div>
                ),
            },
            {
                title: (
                    <Tooltip title="Total General de Habitaciones">
                        <div style={{ textAlign: 'center', fontSize: '10px' }}>
                            Total
                        </div>
                    </Tooltip>
                ),
                key: 'totalGeneral',
                width: 60,
                fixed: 'left',
                align: 'center',
                render: (_, record) => {
                    let totalGeneral = 0;
                    tiposHabitacion.forEach(tipo => {
                        totalGeneral += record[tipo]?.total || 0;
                    });
        
                    return (
                        <div style={{ 
                            fontSize: '11px',
                            fontWeight: 'bold',
                            color: '#1890ff'
                        }}>
                            {totalGeneral}
                        </div>
                    );
                },
            },
            {
                title: (
                    <Tooltip title="Total de Habitaciones Ocupadas">
                        <div style={{ textAlign: 'center', fontSize: '10px' }}>
                            Ocup
                        </div>        
                    </Tooltip>
                ),
                key: 'totalOcupadas',
                width: 60,
                fixed: 'left',
                align: 'center',
                render: (_, record) => {
                    let totalOcupadas = 0;
                    tiposHabitacion.forEach(tipo => {
                        const datos = record[tipo];
                        if (datos) {
                            const total = datos.total || 0;
                            const disponibles = datos.disponibles || 0;
                            // const ocupadas = Math.max(0, total - Math.max(0, disponibles));
                            const ocupadas = disponibles;
                            totalOcupadas += ocupadas;
                        }
                    });
                    
                    return (
                        <div style={{ 
                            fontSize: '11px',
                            fontWeight: 'bold',
                            color: '#fa8c16'
                        }}>
                            {totalOcupadas}
                        </div>
                    );
                },
            },
            {
                title: (
                    <Tooltip title="Total de Habitaciones Disponibles">
                        <div style={{ textAlign: 'center', fontSize: '10px' }}>
                            Disp
                        </div>
                    </Tooltip>
                ),
                key: 'totalDisponibles',
                width: 60,
                fixed: 'left',
                align: 'center',
                render: (_, record) => {
                    let totalDisponibles = 0;
                    let negativo = false;
            
                    tiposHabitacion.forEach(tipo => {
                        const datos = record[tipo];
                        if (datos) {
                            const disponibles = datos.disponibles || 0;
                            totalDisponibles += datos.total - disponibles;
                            if (disponibles < 0) negativo = true;
                        }
                    });
            
                    const color = totalDisponibles > 0 ? '#52c41a' : 
                        totalDisponibles < 0 ? '#ff4d4f' : '#999';
                    const bgColor = totalDisponibles > 0 ? '#f6ffed' : 
                        totalDisponibles < 0 ? '#fff1f0' : '#fafafa';
            
                    return (
                        <div 
                            style={{ 
                                fontSize: '11px',
                                fontWeight: 'bold',
                                color: color,
                                backgroundColor: bgColor,
                                padding: '1px 4px',
                                borderRadius: '2px'
                            }}
                        >
                            {totalDisponibles}
                        </div>
                    );
                },
            },
            {
                title: (
                    <Tooltip title="Porcentaje de Ocupación">
                        <div style={{ textAlign: 'center', fontSize: '10px' }}>
                            %Ocup
                        </div>
                    </Tooltip>
                ),
                key: 'porcentajeOcupacion',
                width: 60,
                fixed: 'left',
                align: 'center',
                render: (_, record) => {
                    let totalGeneral = 0;
                    let totalOcupadas = 0;
            
                    tiposHabitacion.forEach(tipo => {
                        const datos = record[tipo];
                        if (datos) {
                            const total = datos.total || 0;
                            const disponibles = datos.disponibles || 0;
                            const ocupadas = disponibles;
                            totalGeneral += total;
                            totalOcupadas += ocupadas;
                        }
                    });
            
                    const porcentaje = totalGeneral > 0 
                        ? Math.round((totalOcupadas / totalGeneral) * 100)
                        : 0;
            
                    const color = porcentaje > 80 ? '#ff4d4f' : 
                        porcentaje > 60 ? '#fa8c16' : 
                        porcentaje > 30 ? '#52c41a' : '#999';
                    
                    return (
                        <div style={{ 
                                    fontSize: '11px',
                                    fontWeight: 'bold',
                                    color: color
                            }}>
                            {porcentaje}%
                        </div>
                    );
                },
            },    
            {
                title: 'Bloq.',
                dataIndex: 'Bloqueadas',
                key: 'Bloqueadas',
                width: 60, // Más estrecho
                align: 'center',
                render: (num) => (
                    num > 0 ? (
                        <Badge
                            count={num}
                            style={{ 
                                backgroundColor: '#ff4d4f',
                                fontSize: '10px',
                                minWidth: '18px',
                                height: '18px',
                                lineHeight: '18px'
                            }}
                        />
                    ) : (
                        <span style={{ color: '#999', fontSize: '10px' }}>0</span>
                    )
                ),
            },
        ];

        // Agregar columnas para cada tipo de habitación CON ANCHOS MÁS PEQUEÑOS
        tiposHabitacionFiltrados.forEach((tipo, index) => {
            const backgroundColor = index % 2 === 0 ? '#bdb3b338' : 'white';
            const borderColor = '#f0f0f0';

            baseColumns.push({
                title: (
                    <Tooltip title={tipo}>
                        <div style={{ 
                            fontSize: '11px', 
                            fontWeight: 'bold',
                            textAlign: 'center',
                            padding: '2px 0',
                            whiteSpace: 'nowrap',
                            backgroundColor: backgroundColor,
                            borderLeft: '1px solid ' + borderColor,
                            borderRight: index === tiposHabitacionFiltrados.length - 1 ? '1px solid ' + borderColor : 'none',
                            position: 'relative'
                        }}>
                            {tipo.length > 8 ? `${tipo.substring(0, 6)}..` : tipo}
                            {index < tiposHabitacionFiltrados.length - 1 && (
                                <div style={{
                                    position: 'absolute',
                                    right: 0,
                                    top: '20%',
                                    bottom: '20%',
                                    width: '1px',
                                    backgroundColor: '#e8e8e8'
                                }} />
                            )}
                        </div>
                    </Tooltip>
                ),
                key: tipo,
                align: 'center',
                onHeaderCell: () => ({
                    style: {
                        backgroundColor: backgroundColor,
                        borderLeft: '1px solid ' + borderColor,
                        borderRight: index === tiposHabitacionFiltrados.length - 1 ? '1px solid ' + borderColor : 'none',
                        padding: '0'
                    }
                }),
                onCell: () => ({
                    style: {
                        backgroundColor: backgroundColor,
                        borderLeft: '1px solid ' + borderColor,
                        borderRight: index === tiposHabitacionFiltrados.length - 1 ? '1px solid ' + borderColor : 'none',
                        position: 'relative'
                    }
                }),
                children: [
                    {
                        title: 'Tot',
                        dataIndex: tipo,
                        key: `${tipo}-total`,
                        width: 45, // Más estrecho
                        align: 'center',
                        render: (value) => (
                            <div style={{ 
                                fontSize: '11px',
                                fontWeight: 'bold',                                
                                color: '#1890ff'
                            }}>
                                {value?.total || 0}
                            </div>
                        ),
                    },
                    {
                        title: 'Ocu', // Disponibles (valor directo de la base de datos)
                        dataIndex: tipo,
                        key: `${tipo}-ocupadas`,
                        width: 45,
                        align: 'center',
                        render: (value) => {
                            const disponibles = value?.disponibles || 0; // Este es el valor DIRECTAMENTE de la BD
                            const color = disponibles > 0 ? '#52c41a' : 
                                                disponibles < 0 ? '#ff4d4f' : '#d9d9d9';
                            const bgColor = disponibles > 0 ? '#f6ffed' : 
                                                disponibles < 0 ? '#fff1f0' : '#fafafa';
            
                            return (
                                <div 
                                    style={{ 
                                        fontSize: '11px',
                                        fontWeight: 'bold',
                                        color: color,
                                        backgroundColor: bgColor,
                                        padding: '1px 4px',
                                        borderRadius: '2px',
                                        minWidth: '25px'
                                    }}
                                >
                                    {disponibles}
                                </div>
                            );
                        },                
                    },
                    {
                        title: 'Dis', // Ocupadas (calculadas: Total - Disponibles)
                        dataIndex: tipo,
                        key: `${tipo}-disponibles`,
                        width: 45,
                        align: 'center',
                        render: (value) => {
                            const total = value?.total || 0;
                            const disponibles = value?.disponibles || 0;
                            const ocupadas = total - disponibles;

                            const color = ocupadas > 0 ? '#52c41a' : 
                                    ocupadas < 0 ? '#ff4d4f' : '#d9d9d9';
                            const bgColor = ocupadas > 0 ? '#f6ffed' : 
                                    ocupadas < 0 ? '#fff1f0' : '#fafafa';          
            
                            return (
                                <div style={{ 
                                    fontSize: '11px',
                                    fontWeight: 'bold',
                                    color: color,
                                    backgroundColor: bgColor,            
                                }}>
                                    {ocupadas}
                                </div>
                            );
                        },
                    },        
                ],
            });
        });

        baseColumns.push({
            title: 'Acciones',
            key: 'actions',
            width: 120,
            fixed: 'right',
            render: (_, record) => (
                <Space size="small">
                    <Tooltip title="Ver detalles">
                        <Button
                            type="default"
                            icon={<EyeOutlined />}
                            size="small"
                            onClick={() => handleView(record)}
                        />
                    </Tooltip>
                    {/* <Tooltip title="Exportar día">
                        <Button
                            type="primary"
                            icon={<ExportOutlined />}
                            size="small"
                            onClick={() => handleExportDia(record)}
                        />
                    </Tooltip> */}
                </Space>
            ),
        });        

        return baseColumns;
    };

    const getColumnsVertical = () => {
        const baseColumns = [
            {
                title: 'Tipo Habitación',
                dataIndex: 'tipo',
                key: 'tipo',
                width: 120, // Más estrecho
                fixed: 'left',
                render: (tipo) => (
                    <div style={{ 
                        fontWeight: 'bold', 
                        fontSize: '12px',
                        whiteSpace: 'nowrap'
                    }}>
                        {tipo.length > 10 ? `${tipo.substring(0, 8)}..` : tipo}
                    </div>
                ),
            },
            {
                title: 'Total',
                dataIndex: 'totalGeneral',
                key: 'totalGeneral',
                width: 60, // Más estrecho
                align: 'center',
                render: (total) => (
                    <Tag color="blue" style={{ fontSize: '11px', padding: '1px 4px' }}>
                        {total}
                    </Tag>
                ),
            },
            {
                title: 'O Prom',
                dataIndex: 'ocupadasPromedio',
                key: 'ocupadasPromedio',
                width: 70, // Más estrecho
                align: 'center',
                render: (promedio) => (
                    <div style={{ fontSize: '12px', fontWeight: 'bold', color: '#fa8c16' }}>
                        {promedio}
                    </div>
                ),
            },
            {
                title: 'D Prom',
                dataIndex: 'disponiblesPromedio',
                key: 'disponiblesPromedio',
                width: 70, // Más estrecho
                align: 'center',
                render: (promedio) => (
                    <div style={{ fontSize: '12px', fontWeight: 'bold', color: '#52c41a' }}>
                        {promedio}
                    </div>
                ),
            },
        ];

        const datosParaColumnas = tipoHabitacionFilter ? data.filter(dia => dia[tipoHabitacionFilter]) : data;

        datosParaColumnas.slice(0, 31).forEach(dia => {
            baseColumns.push({
                title: (
                    <Tooltip title={`${dia.DiaSemana} - ${dayjs(dia.Fecha).format('DD/MM')}`}>
                        <div style={{ fontSize: '10px', textAlign: 'center', padding: '1px' }}>
                            <div style={{ fontWeight: 'bold', fontSize: '10px' }}>{dayjs(dia.Fecha).format('DD/MM')}</div>
                            <div style={{ color: '#666', fontSize: '9px' }}>{dia.DiaSemana.substring(0, 3)}</div>
                        </div>
                    </Tooltip>
                ),
                key: dia.Fecha,
                align: 'center',
                width: 65,
                children: [
                    {
                        title: 'D', // Disponibles
                        key: `${dia.Fecha}-disponibles`,
                        width: 30,
                        align: 'center',
                        render: (_, record) => {
                            const tipo = record.tipo;
                            const datos = dia[tipo];
                            if (!datos) return null; 
                            const disponibles = datos?.disponibles || 0; // Valor DIRECTAMENTE de la BD
                            const color = disponibles > 0 ? '#52c41a' : 
                                    disponibles < 0 ? '#ff4d4f' : '#d9d9d9';
                            
                            return (
                                <div 
                                    style={{ 
                                        fontSize: '10px',
                                        fontWeight: 'bold',
                                        color: color,
                                        backgroundColor: disponibles > 0 ? '#f6ffed' : disponibles < 0 ? '#fff1f0' : '#fafafa',
                                        padding: '1px 2px',
                                        borderRadius: '2px',
                                        minWidth: '25px'
                                    }}
                                >
                                    {disponibles}
                                </div>
                            );
                        },
                    },
                    {
                        title: 'O', // Ocupadas (calculadas)
                        key: `${dia.Fecha}-ocupadas`,
                        width: 30,
                        align: 'center',
                        render: (_, record) => {
                            const tipo = record.tipo;
                            const datos = dia[tipo];
                            if (!datos) return null; 
                            const total = datos?.total || 0;
                            const disponibles = datos?.disponibles || 0;
                            const ocupadas = Math.max(0, total - Math.max(0, disponibles));
                            
                            return (
                                <div style={{ 
                                    fontSize: '10px',
                                    fontWeight: 'bold',
                                    color: ocupadas > 0 ? '#fa8c16' : '#999',
                                    padding: '1px'
                                }}>
                                    {ocupadas}
                                </div>
                            );
                        },
                    },
                ],
            });
        });

        return baseColumns;
    };

    const extraerTiposUnicosDeDatos = (datos) => {
        const tiposSet = new Set();
    
        datos.forEach(dia => {
            Object.keys(dia).forEach(key => {
                if (typeof dia[key] === 'object' && dia[key] !== null &&  !['Fecha', 'DiaSemana', 'NumeroCampos', 'Bloqueadas', 'Ficticias'].includes(key)) {
                    tiposSet.add(key);
                }
            });
        });
    
        return Array.from(tiposSet).sort();
    };


    // Cargar datos
    const fetchData = async () => {
        if (!fechas || fechas.length < 2) {
            message.warning('Por favor seleccione un rango de fechas');
            return;
        }

        setLoading(true);
        try {
            const token = localStorage.getItem('token');
            const fechaInicio = dayjs(fechas[0]).format('YYYY-MM-DD');
            const fechaFin = dayjs(fechas[1]).format('YYYY-MM-DD');
      
            // Actualizar texto de fechas para mostrar
            setFechasTexto(`${dayjs(fechaInicio).format('DD/MM/YYYY')} - ${dayjs(fechaFin).format('DD/MM/YYYY')}`);
      
            // Parámetros de consulta
            const queryParams = {
                fechaInicio,
                fechaFin,
                tipoHabitacion: tipoHabitacionFilter,
                diaSemana: diaSemanaFilter,
                search: searchText,
                sortField: sortedInfo.field || 'Fecha',
                sortOrder: sortedInfo.order === 'descend' ? 'DESC' : 'ASC',
                vista:vista
            };
      
            const response = await axios.get(`${BASE_URL}/api/habitaciones-especiales`, {
                headers: { Authorization: `Bearer ${token}` },
                params: queryParams
            });

            setData(response.data.data || []);
            setEstadisticas(response.data.estadisticas || {});
            setTiposHabitacion(response.data.tiposHabitacion || []);

            const todosLosTipos = extraerTiposUnicosDeDatos(response.data.data);
            setTodosLosTiposDisponibles(todosLosTipos);      
      
        } catch (error) {
            console.error('❌ Error cargando habitaciones especiales:', error);
            message.error('Error al cargar los datos');
            setData([]);
            setEstadisticas(null);
            setTiposHabitacion([]);
            setTodosLosTiposDisponibles([]);
        } finally {
            setLoading(false);
            setSearchLoading(false);
        }
    };

    const tiposHabitacionFiltrados = tipoHabitacionFilter 
        ? tiposHabitacion.filter(tipo => tipo === tipoHabitacionFilter)
        : tiposHabitacion;

    // Handlers
    const handleSearch = () => {
        if (!fechas || fechas.length < 2) {
            message.warning('Por favor seleccione un rango de fechas');
            return;
        }
    
        setSearchLoading(true);
        fetchData();
    };

    const handleView = (record) => {
        // Calcular totales generales del día
        let totalGeneral = 0;
        let totalOcupadas = 0;
        let totalDisponibles = 0;
  
        tiposHabitacion.forEach(tipo => {
            const datos = record[tipo] || {};
            const total = datos.total || 0;
            const disponibles = datos.disponibles || 0;
            const ocupadas = Math.max(0, total - Math.max(0, disponibles));
    
            totalGeneral += total;
            totalOcupadas += ocupadas;
            totalDisponibles += disponibles;
        });
  
        const porcentajeOcupacion = totalGeneral > 0 
            ? Math.round((totalOcupadas / totalGeneral) * 100)
            : 0;

        // Calcular ocupadas para cada tipo
        const detallesTipos = tiposHabitacion.map(tipo => {
            const datos = record[tipo] || {};
            const total = datos.total || 0;
            const disponibles = datos.disponibles || 0;
            const ocupadas = Math.max(0, total - Math.max(0, disponibles));
    
            return {
                tipo,
                total,
                disponibles,
                ocupadas,
                porcentajeOcupacion: total > 0 ? Math.round((ocupadas / total) * 100) : 0
            };
        });

        Modal.info({
            title: `Tipos de habitación - ${dayjs(record.Fecha).format('DD/MM/YYYY')}`,
            width: 900,
            content: (
                <div style={{ marginTop: 20 }}>
                    <Row gutter={[16, 16]}>
                        {/* Totales generales en tarjetas */}
                        <Col span={6}>
                            <Card size="small" style={{ backgroundColor: '#e6f7ff', textAlign: 'center' }}>
                                <Statistic
                                    title="Total Habitaciones"
                                    value={totalGeneral}
                                    valueStyle={{ fontSize: '20px', color: '#1890ff', fontWeight: 'bold' }}
                                />
                            </Card>
                        </Col>
          
                        <Col span={6}>
                            <Card size="small" style={{ backgroundColor: '#fff7e6', textAlign: 'center' }}>
                                <Statistic
                                    title="Ocupadas"
                                    value={totalOcupadas}
                                    valueStyle={{ fontSize: '20px', color: '#fa8c16', fontWeight: 'bold' }}
                                />
                            </Card>
                        </Col>
          
                        <Col span={6}>
                            <Card size="small" style={{ 
                                backgroundColor: totalDisponibles > 0 ? '#f6ffed' : totalDisponibles < 0 ? '#fff1f0' : '#fafafa',
                                textAlign: 'center' 
                            }}>
                                <Statistic
                                    title="Disponibles"
                                    value={totalDisponibles}
                                    valueStyle={{ 
                                        fontSize: '20px', 
                                        color: totalDisponibles > 0 ? '#52c41a' : totalDisponibles < 0 ? '#ff4d4f' : '#999',
                                        fontWeight: 'bold' 
                                    }}
                                />
                            </Card>
                        </Col>
          
                        <Col span={6}>
                            <Card size="small" style={{ 
                                backgroundColor: '#f0f8ff',
                                textAlign: 'center' 
                            }}>
                                <Statistic
                                    title="% Ocupación"
                                    value={porcentajeOcupacion}
                                    suffix="%"
                                    valueStyle={{ 
                                    fontSize: '20px', 
                                    color: porcentajeOcupacion > 80 ? '#ff4d4f' : 
                                                        porcentajeOcupacion > 60 ? '#fa8c16' : 
                                                        porcentajeOcupacion > 30 ? '#52c41a' : '#999',
                                    fontWeight: 'bold' 
                                }}
                            />
                        </Card>
                    </Col>
          
                    {record.Bloqueadas > 0 && (
                        <Col span={24}>
                            <Alert
                                message={
                                    <Space>
                                        <LockOutlined />
                                        <Text>Habitaciones bloqueadas: </Text>
                                        <Tag color="red">{record.Bloqueadas}</Tag>
                                        <Text type="secondary">(no disponibles para venta)</Text>
                                    </Space>
                                }
                                type="warning"
                                showIcon={false}
                            />
                        </Col>
                    )}
          
                    <Col span={24}>
                        <Divider />
                        <Title level={5}>Detalle por tipo de habitación</Title>
                    </Col>
          
                    {detallesTipos.map(detalle => (
                        <Col span={8} key={detalle.tipo}>
                            <Card 
                                size="small" 
                                style={{ 
                                    marginBottom: 8,
                                    borderLeft: `4px solid ${detalle.porcentajeOcupacion > 70 ? '#ff4d4f' : 
                                       detalle.porcentajeOcupacion > 30 ? '#fa8c16' : '#52c41a'}`
                                }}
                            >
                                <div style={{ textAlign: 'center' }}>
                                    <div style={{ 
                                        fontWeight: 'bold', 
                                        fontSize: '12px', 
                                        marginBottom: 8,
                                        color: '#1890ff'
                                    }}>
                                        {detalle.tipo}
                                    </div>
                                    <Row gutter={8}>
                                        <Col span={8}>
                                            <div style={{ fontSize: '10px', color: '#666' }}>Total</div>
                                            <div style={{ fontSize: '14px', fontWeight: 'bold' }}>
                                                {detalle.total}
                                            </div>
                                        </Col>
                                        <Col span={8}>
                                            <div style={{ fontSize: '10px', color: '#666' }}>Ocupadas</div>
                                            <div style={{ 
                                                fontSize: '14px', 
                                                fontWeight: 'bold',
                                                color: '#fa8c16'
                                            }}>
                                                {detalle.ocupadas}
                                            </div>
                                        </Col>
                                        <Col span={8}>
                                            <div style={{ fontSize: '10px', color: '#666' }}>Disponibles</div>
                                            <div style={{ 
                                                fontSize: '14px', 
                                                fontWeight: 'bold',
                                                color: detalle.disponibles > 0 ? '#52c41a' : 
                                                            detalle.disponibles < 0 ? '#ff4d4f' : '#999'
                                            }}>
                                                {detalle.disponibles}
                                            </div>
                                        </Col>
                                    </Row>
                                    {detalle.total > 0 && (
                                        <div style={{ 
                                            marginTop: 8, 
                                            fontSize: '10px',
                                            color: detalle.porcentajeOcupacion > 70 ? '#ff4d4f' : 
                                                detalle.porcentajeOcupacion > 30 ? '#fa8c16' : '#52c41a'
                                        }}>
                                            {detalle.porcentajeOcupacion}% ocupación
                                    </div>
                                )}
                                </div>
                            </Card>
                        </Col>
                    ))} 
                    </Row>
                </div>
            ),
            onOk() {},
        });
    };

    const handleExportDia = (record) => {
        message.info(`Exportando datos para ${record.Fecha}`);
        // Implementar lógica de exportación
    };

    const handleExportPDF = () => {
        message.info('Exportando a PDF...');
        // Implementar exportación PDF
    };

    const handleExportExcel = () => {
        message.info('Exportando a Excel...');
        // Implementar exportación Excel
    };


  // Preparar datos para modo vertical con ocupadas calculadas
    const getDataVertical = () => {
        if (!estadisticas?.porTipo) return [];

        const tiposParaMostrar = tipoHabitacionFilter 
            ? [tipoHabitacionFilter].filter(tipo => estadisticas.porTipo[tipo])
            : Object.keys(estadisticas.porTipo);
  
        return tiposParaMostrar.map(tipo => {
            const stats = estadisticas.porTipo[tipo];
    
            // Calcular ocupadas promedio CORRECTAMENTE
            let totalOcupadas = 0;
            let totalDisponibles = 0;
    
            data.forEach(dia => {
                const datos = dia[tipo];
                if (datos) {
                    const total = datos.total || 0;
                    const disponibles = datos.disponibles || 0;
                    const ocupadas = Math.max(0, total - Math.max(0, disponibles));
                    totalOcupadas += ocupadas;
                    totalDisponibles += disponibles;
                }
            });
    
            const ocupadasPromedio = data.length > 0 
                ? parseFloat((totalOcupadas / data.length).toFixed(1))
                : 0;
    
            const disponiblesPromedio = data.length > 0 
                ? parseFloat((totalDisponibles / data.length).toFixed(1))
                : 0;
    
            return {
                key: tipo,
                tipo,
                totalGeneral: stats.total,
                ocupadasPromedio,
                disponiblesPromedio,
                ...data.reduce((acc, dia) => {
                    acc[dia.Fecha] = dia[tipo];
                    return acc;
                }, {})
            };
        });
    };

    // Barra de búsqueda con leyenda de fechas
    const searchBar = (
        <Card 
            size="small" 
            style={{ 
                marginBottom: 16, 
                borderRadius: '8px',
                borderLeft: '4px solid #1890ff'
            }}
            bodyStyle={{ padding: '16px' }}
        >
            <Row gutter={[16, 16]} align="middle">
                <Col span={24}>
                    <Space size="middle" wrap>
                        <RangePicker 
                            onChange={setFechas}
                            style={{ width: 250 }}
                            placeholder={['Fecha inicio', 'Fecha fin']}
                            allowClear={false}
                            size="middle"
                        />
            
                        {todosLosTiposDisponibles.length > 0 && (
                            <Select
                                placeholder="Filtrar por tipo"
                                style={{ width: 180 }}
                                value={tipoHabitacionFilter}
                                onChange={setTipoHabitacionFilter}
                                allowClear
                                size="middle"
                                showSearch
                                optionFilterProp="children"
                                filterOption={(input, option) =>
                                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                }
                            >
                                <Option value="">Todos los tipos</Option>
                                {todosLosTiposDisponibles.map(tipo => (
                                    <Option key={tipo} value={tipo}>
                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                            <Tag 
                                                color={tipo.startsWith('D') ? 'blue' : 
                                                                tipo.startsWith('F') ? 'orange' : 
                                                                tipo.startsWith('S') ? 'purple' : 'green'}
                                                style={{ marginRight: 8, fontSize: '10px' }}
                                            >
                                                {tipo}
                                            </Tag>
                                            <span>{tipo}</span>
                                        </div>
                                    </Option>
                                ))}
                            </Select>
                        )}
            
                        {/* <Segmented
                            value={vista}
                            onChange={setVista}
                            options={[
                                { value: 'normal', icon: <TableOutlined />, label: 'Normal' },
                                { value: 'agrupado', icon: <UnorderedListOutlined />, label: 'Agrupado' }
                            ]}
                        />  */}

                        {/* Botones de acción */}
                        <Button
                            type="primary"
                            icon={<SearchOutlined />}
                            onClick={handleSearch}
                            loading={searchLoading}
                            size="middle"
                        >
                            Consultar
                        </Button>
            
                    </Space>
                </Col>
        
                {todosLosTiposDisponibles.length > 0 && (
                    <Col span={24}>
                        {/* <Alert
                            message={
                                <Space wrap>
                                    <FilterOutlined />
                                    <Text strong>Tipos de habitación encontrados:</Text>
                                    <Tag color="blue">
                                        {todosLosTiposDisponibles.length} tipos
                                    </Tag>
                                    {tipoHabitacionFilter && (
                                        <Tag color="green" closable onClose={() => setTipoHabitacionFilter('')}>
                                            Filtrado: {tipoHabitacionFilter}
                                        </Tag>
                                    )}
                                    <Text type="secondary" style={{ fontSize: '12px' }}>
                                        {tiposHabitacionFiltrados.length} mostrados
                                    </Text>
                                </Space>
                            }
                            type="info"
                            showIcon={false}
                            style={{ 
                                backgroundColor: '#f0f8ff',
                                border: '1px solid #d1e9ff',
                                padding: '8px 12px'
                            }}
                        /> */}
                    </Col>
                )}

                {/* Leyenda de fechas */}
                {fechasTexto && (
                    <Col span={24}>
                        <Alert
                            message={
                                <Space>
                                    <HistoryOutlined />
                                    <Text strong>Período consultado:</Text>
                                    <Tag color="blue" icon={<CalendarOutlined />}>
                                        {fechasTexto}
                                    </Tag>
                                </Space>
                            }
                            type="info"
                            showIcon={false}
                            style={{ 
                                backgroundColor: '#f0f8ff',
                                border: '1px solid #d1e9ff'
                            }}
                        />
                    </Col>
                )}
            </Row>
        </Card>
    );

    // Estadísticas con ocupadas
    const estadisticasComponent = estadisticas && (
        <Row gutter={[16, 16]} style={{ marginBottom: 24 }}>
            <Col span={4}>
                <Statistic 
                    title="Total Días" 
                    value={estadisticas.totalDias}
                    prefix={<CalendarOutlined />}
                    valueStyle={{ color: '#1890ff', fontSize: '20px' }}
                />
            </Col>
            <Col span={5}>
                <Statistic 
                    title="Disp. Promedio" 
                    value={parseFloat(estadisticas.promedioDisponibilidad || 0).toFixed(1)}
                    suffix="hab/día"
                    prefix={<CheckCircleOutlined />}
                    valueStyle={{ color: '#13c2c2', fontSize: '20px' }}
                />
            </Col>
        </Row>
    );

    return (
        <PageContainer
            title="Planing por tipo de habitación"
            subtitle="Listado de disponibilidad por tipo de habitación"
            icon={<HomeOutlined />}
            loading={loading}
            onRefresh={fetchData}
            badgeStatus="processing"
            extra={
                <Space>
                    <Button
                        icon={<ExportOutlined />}
                        onClick={handleExportExcel}
                        size="middle"
                    >
                        Excel
                    </Button>
                    <Button
                        icon={<PrinterOutlined />}
                        onClick={handleExportPDF}
                        size="middle"
                    >
                        PDF
                    </Button>
                </Space>
            }
            cardStyle={{
                borderRadius: '12px',
                boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)',
                width: '100%',
                maxWidth: '100%',
                overflow: 'hidden'
            }}
        >
        
        {/* Barra de búsqueda con leyenda */}
        {searchBar}
      
        {/* Estadísticas */}
        {estadisticasComponent}
      
        {/* Controles adicionales */}
        {data.length > 0 && (
            <Card 
                size="small" 
                style={{ 
                    marginBottom: 16,
                    backgroundColor: '#fafafa',
                    borderLeft: '4px solid #722ed1'
                }}
            >
                <Row gutter={[16, 16]} align="middle">
                    <Col flex="auto">
                        <Space>
                            <Text strong>Modo de visualización:</Text>
                            <Segmented
                                options={[
                                    { label: 'Horizontal (fechas)', value: 'horizontal' },
                                    { label: 'Vertical (tipos)', value: 'vertical' }
                                ]}
                                value={modoVista}
                                onChange={setModoVista}
                                size="small"
                            />                
                        </Space>
                    </Col>
            
                    <Col>
                        <Text type="secondary" style={{ fontSize: '12px' }}>
                            {data.length} registros • {tiposHabitacion.length} tipos
                        </Text>
                    </Col>
                </Row>
            </Card>
        )}
      
        {/* Tabla principal SIN PAGINACIÓN */}
            {modoVista === 'horizontal' ? (
                <div style={{ 
                    overflowX: 'auto', 
                    width: '100%',
                    marginBottom: 16,
                    border: '1px solid #f0f0f0',
                    borderRadius: '8px'
                }}>
                    <Table
                        columns={getColumnsHorizontal()}
                        dataSource={data}
                        rowKey="Fecha"
                        loading={loading}
                        pagination={false}
                        scroll={{ y: 'calc(100vh - 450px)' }} // SOLO SCROLL VERTICAL
                        style={{
                            minWidth: '100%',
                            width: 'auto'
                        }}
                        size="middle"
                        bordered
                        locale={{
                            emptyText: (
                                <div style={{ padding: '40px 0', textAlign: 'center' }}>
                                    <InfoCircleOutlined style={{ fontSize: 48, color: '#d9d9d9', marginBottom: 16 }} />
                                    <div>
                                        <Title level={4} type="secondary">
                                            No hay datos para mostrar
                                        </Title>
                                        <Text type="secondary">
                                            Seleccione un rango de fechas y haga clic en Consultar
                                        </Text>
                                    </div>
                                </div>
                            )
                        }}
                    />
                </div>
            ) : (
                // Tabla modo vertical SIN PAGINACIÓN y SIN SCROLL HORIZONTAL
                <div style={{ 
                    overflowX: 'auto', 
                    width: '100%',
                    marginBottom: 16,
                    border: '1px solid #f0f0f0',
                    borderRadius: '8px'
                }}>
                    <Table
                        columns={getColumnsVertical()}
                        dataSource={getDataVertical()}
                        rowKey="tipo"
                        loading={loading}
                        pagination={false}
                        scroll={{ y: 'calc(100vh - 450px)' }} // SOLO SCROLL VERTICAL
                        style={{
                            minWidth: '100%',
                            width: 'auto'
                        }}
                        size="middle"
                        bordered
                    />
                </div>
            )}            
        </PageContainer>
    );
};

export default PlaningHabitacionesVenta;